export const LANGUAGE_EN = 'en-US';
export const LANGUAGE_CN = 'zh-CN';
